export default {
  breakpoint: {
    desktop: '1024px'
  },
  duration: 250,
  gutter: 10,
  sections: {
    selectors: {
      container: '.container',
    },
    classNames: {
      hide: 'hide'
    }
  }
}